import { useQuery } from '@tanstack/react-query'
import { extractData, useBuildRequest, useGenericErrorHandler } from 'hooks/api/base'
import { DateTime } from 'luxon'

export function useSuspectScoreQuantilesQuery(subscriptionId?: string, timestamp?: DateTime) {
  const buildRequest = useBuildRequest()
  const { withErrorHandling } = useGenericErrorHandler()
  const startOfDay = timestamp?.toUTC().startOf('day').toISO()

  return useQuery({
    queryKey: ['suspect-score-quantiles', subscriptionId, startOfDay],
    queryFn: () =>
      extractData(
        withErrorHandling(
          buildRequest('suspectScoreQuantiles', {
            params: { subscriptionId: subscriptionId! },
            queryParams: { timestamp: startOfDay! },
          })
        )
      ),
    enabled: subscriptionId != null && startOfDay != null,
    staleTime: Infinity,
  })
}
